import { buildListCategoriesMessage, buildListTagFieldMessage, buildListTicketMessage, buildMessageSuggestUsingAI, checkMessageOutOfSession, createMessageList, postMessage, getOptionDisplayLength, buildLoadingDrilldownMessage } from "./handler/ChatBoxHandler";
import { fetchRemainingFields, fetchFieldItems, decideNextStep, enrichFieldsWithPriority } from './service/chatBotDataService';
import Constant from '@/common/constant/Constant';
import Utils from "@/common/utils/utils";
import { memo, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { updatePreviewSettingAtom } from "@/state/atom/chatBotPreview";
import TicketImagePreviewList from "./TicketImagePreviewList";
import DisplayOptionBySetting from "./DisplayOptionBySetting";



function ListTagFieldItem(props) {

    let {message,onClickHandler,chatbotSettings,messages,setMessages, usingAI,listTagFieldSkip,setListTagFieldSkip,enableListTicket,getMessage,resolvedMessages} = props;
    let {listTagFieldSelected,filterPublicKnowledge,listSelectedItemOfSession,listTagFieldOfSelectedCategory,handleWhenRenderTagFieldPriority, listTagItemSelected} = props;
    let {supportThreadIdState,affiliationOrganization,setListTagFieldSelected} = props;
    let {isModePreview,listCategories,projectId,subDomain,categoryIdSelected,isLoadingStep} = props
    const [maxNumberAnswer,setMaxNumberAnswer] = useState(0);
    const [useImageInAnswer,setUseImageAnswer] = useState(false)
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [messageState, setMessagesState] = useState(message)
    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])
    useEffect(() => {
        if (!isModePreview) {
            setMaxNumberAnswer(chatbotSettings.maxNumberAnswer);
            setUseImageAnswer(chatbotSettings.useImageInAnswer)
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }
            if(useImageInAnswer !== previewSetting.useImageInAnswer){
                setUseImageAnswer(previewSetting.useImageInAnswer)
            }
        }
    }, [previewSetting]);
    
    let isShowSeeMore = maxNumberAnswer < messageState?.content?.length;

    const onClickSkipHandler = async (idOfMessage) => {
        if (checkMessageOutOfSession(messages, idOfMessage)) return;
        if (isLoadingStep) return;
        const itemList = messageState.content;
        const idOfTagField = itemList[0]?.idOfTagField;
        if (idOfTagField) {
            setListTagFieldSkip(pev => [...pev, idOfTagField]);
        }

        const categoryDetail = listCategories?.find(category => category.id === categoryIdSelected);
        if (!categoryDetail) return;

        const newListTagFieldSkip = [...listTagFieldSkip, idOfTagField].filter(Boolean);
        let newListTagFieldSelected = [...listTagFieldSelected];
        if (idOfTagField && !newListTagFieldSelected.includes(idOfTagField)) {
            newListTagFieldSelected = [...newListTagFieldSelected, idOfTagField];
        }

        // Show loading immediately
        const loadingMsg = buildLoadingDrilldownMessage();
        setMessages(prev => [...prev, loadingMsg]);

        try {
            const result = await fetchRemainingFields({
                projectId,
                subDomain,
                structure: categoryDetail.viewStructure,
                corporationId: affiliationOrganization,
                tagFieldQuery: filterPublicKnowledge.tagFieldSelected || [],
                listTagFieldSelected: newListTagFieldSelected,
                listTagItemSelected,
                listTagFieldSkip: newListTagFieldSkip
            });

            const maxHitTicket = isModePreview ? previewSetting.numberHitKnowledgeTicket : chatbotSettings.numberHitKnowledgeTicket;
            const enrichedFields = enrichFieldsWithPriority(result.remainingFields, listTagFieldOfSelectedCategory);
            const nextStep = decideNextStep({
                totalTicketMatching: result.totalTicketMatching,
                remainingFields: enrichedFields,
                maxHitTicket,
                enableListTicket
            });

            let newMessage = {};
            switch (nextStep.type) {
                case Constant.CHATBOT_NEXT_STEP.SHOW_TICKET_LIST:
                    newMessage = enableListTicket ? buildListTicketMessage(
                        filterPublicKnowledge.tagFieldSelected,
                        messages.length,
                        listSelectedItemOfSession,
                        usingAI
                    ) : buildMessageSuggestUsingAI(messages.length, resolvedMessages);
                    break;
                case Constant.CHATBOT_NEXT_STEP.SHOW_FIELD_PRIORITY: {
                    const priorityField = nextStep.field;
                    setListTagFieldSelected(prev => [...prev, priorityField.id]);
                    const fieldItemsResult = await fetchFieldItems({
                        projectId,
                        subDomain,
                        structure: categoryDetail.viewStructure,
                        corporationId: affiliationOrganization,
                        targetFieldId: priorityField.id,
                        tagFieldQuery: filterPublicKnowledge.tagFieldSelected || [],
                        listTagFieldSelected: [...newListTagFieldSelected, priorityField.id],
                        listTagItemSelected
                    });
                    newMessage = handleWhenRenderTagFieldPriority(priorityField, fieldItemsResult.items, false, listTagItemSelected);
                    break;
                }
                case Constant.CHATBOT_NEXT_STEP.SHOW_FIELD_LIST:
                    newMessage = buildListTagFieldMessage(nextStep.fields, listTagFieldSelected, 1, false, usingAI, listTagFieldSelected, listTagItemSelected);
                    break;
                default:
                    break;
            }

            // Replace loading with real response
            setMessages(prev => {
                const withoutLoading = prev.filter(m => m.idMessage !== loadingMsg.idMessage);
                return [...withoutLoading, newMessage];
            });
            createMessageList([newMessage], supportThreadIdState, affiliationOrganization, isModePreview);
        } catch (error) {
            // Fallback: remove loading and show ticket list on error
            const fallbackMessage = enableListTicket ? buildListTicketMessage(
                filterPublicKnowledge.tagFieldSelected,
                messages.length,
                listSelectedItemOfSession,
                usingAI
            ) : buildMessageSuggestUsingAI(messages.length, resolvedMessages);
            setMessages(prev => {
                const withoutLoading = prev.filter(m => m.idMessage !== loadingMsg.idMessage);
                return [...withoutLoading, fallbackMessage];
            });
        }
    };

    const onClickBackToListFormHandler = () => {
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        const nextMessage = buildListCategoriesMessage(listCategories);
        postMessage(
            nextMessage,
            supportThreadIdState,
            affiliationOrganization,
            false,
            isModePreview
        );
        setMessages(pev => [...pev, nextMessage]);
    };

    return (
        <div className={props.isMaximizedPanel ? 'message-text  maximized-form-text' : 'message-text'}>
            <div className="text-question text-question-tag-item">{
                getMessage(
                    messageState?.usingAI ? 'bot_selection_prompt_ai' : 'bot_selection_prompt',
                    { SelectedItem: messageState?.nameOption }
                )
            }</div>
            {messageState?.content?.slice(0, maxNumberAnswer)?.map(option => {
                if (Utils.isEmptyString(option.firstImage) || !useImageInAnswer) {
                    return <DisplayOptionBySetting 
                        key={option.id}
                        label={option.name}
                        optionDisplayLength={getOptionDisplayLength(chatbotSettings, previewSetting)}
                        onClickHandler={() => !isLoadingStep && onClickHandler(option, messageState.idMessage)}
                        isMaximizedPanel={props?.isMaximizedPanel}
                    />
                    // return <OverFlowTooltipWithTabsMui
                    //     className={`option-form ${props?.isMaximizedPanel ? 'maximized-form': 'minimized-form'}`}
                    //     onClick={e => {
                    //         onClickHandler(option, messageState.idMessage);
                    //     }}
                    //     value={option.name}
                    //     key={option.id}
                    // />;
                } else {
                    return (
                        <TicketImagePreviewList
                            onClick={e => {
                                onClickHandler(option, messageState.idMessage);
                            }}
                            label={option.name}
                            urlKey={option.firstImage}
                            idMessage={messageState.idMessage}
                            chatbotSettings={chatbotSettings}
                            previewSetting={previewSetting}
                            isMaximizedPanel={props?.isMaximizedPanel}
                        />
                    );
                }
            })}
            {isShowSeeMore && <div className="option-seemore">{getMessage('bot_other_options_hint')}</div>}
            <div className="btn-func-container">
                {messageState.isDisplayBackBtn && (
                    <div
                        className="btn-back-tagfield"
                        style={isLoadingStep ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                        onClick={() => !isLoadingStep && onClickBackToListFormHandler()}
                    >
                        {/* <img src="/assets/image/icon-back-chatbot.svg" alt="sss" /> */}
                        <span className="text-btn-back">{getMessage('bot_back_button_label')}</span>
                    </div>
                )}
                <div
                    className="btn-skip-tagfield"
                    style={isLoadingStep ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                    onClick={() => !isLoadingStep && onClickSkipHandler(messageState.idMessage)}
                >
                    <span className="text-btn-skip">{getMessage('bot_skip_button_label')}</span>
                    {/* <img src="/assets/image/icon-skip-chatbot.svg" alt="sss" /> */}
                </div>
            </div>
        </div>
    );
}

export default memo(ListTagFieldItem)